import { useTheme } from '@mui/material'

import { IconProps } from '@f-fertighaus/applications/Next/types/icon'

export const SalesOfficeAvatarPlaceholderIcon = (props: IconProps) => {
  const theme = useTheme()
  const stroke = props.color || theme.palette.primary.main
  return (
    <svg
      width='72'
      height='72'
      viewBox='0 0 47 47'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M45.5 23.4999C45.5 35.6501 35.6503 45.4998 23.5 45.4998C11.3497 45.4998 1.5 35.6501 1.5 23.4999C1.5 11.3497 11.3497 1.5 23.5 1.5C35.6503 1.5 45.5 11.3497 45.5 23.4999Z'
        stroke={stroke}
        strokeWidth='3'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23.5004 9.54688C18.6333 9.54688 14.6879 13.4924 14.6879 18.3594V24.2343C14.6879 29.1013 18.6333 33.0468 23.5004 33.0468C28.3674 33.0468 32.3129 29.1013 32.3129 24.2343V18.3594C32.3129 13.4924 28.3674 9.54688 23.5004 9.54688ZM16.2155 31.8738C12.1056 33.2848 7.86644 35.9409 7.38867 40.6074C11.5956 44.5709 17.2643 46.9999 23.5004 46.9999C29.7364 46.9999 35.4051 44.5709 39.612 40.6074C39.1343 35.9409 34.8952 33.2848 30.7852 31.8738C29.034 33.9391 26.4203 35.25 23.5004 35.25C20.5804 35.25 17.9667 33.9391 16.2155 31.8738Z'
        fill={stroke}
      />
    </svg>
  )
}
